import PropTypes from "prop-types";

// MUI components
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

// assets
import filterAcrossProducts from "../../assets/icons/filterAcross.png";

// redux
import { useSelector, useDispatch } from "react-redux";
import { loadIsFilterAcrossProductsState } from "store/features/consumerFilterSlice";
import { loadIsFilterAcrossProductsForCorrelationState } from "store/features/correlationSlice";

function FilterAcrossProductsToggleComponent({ type = "" }) {
    const dispatch = useDispatch();
    const isFilterAcrossProductsStoreData = useSelector((state) => state.consumerFilterStore.isFilterAcrossProducts);
    const isFilterAcrossProductsForCorrelationStoreData = useSelector((state) => state.correlationStore.isFilterAcrossProductsForCorrelation);

    const handleFilterAcrossProductsChange = () => {
        if (type === "correlation") {
            dispatch(loadIsFilterAcrossProductsForCorrelationState(!isFilterAcrossProductsForCorrelationStoreData));
        } else {
            dispatch(loadIsFilterAcrossProductsState(!isFilterAcrossProductsStoreData));
        }
    };

    return (
        <Button
            size="small"
            className="custom-btn custom-btn-outlined-2 color-blue me-4 bold-content"
            variant="outlined"
            startIcon={
                <img
                    style={{ height: "16px" }}
                    src={filterAcrossProducts}
                    alt="Filter Across Products"
                />
            }
        >
            Filter across products
            <Switch
                size="small"
                checked={type === "correlation" ? isFilterAcrossProductsForCorrelationStoreData : isFilterAcrossProductsStoreData}
                onChange={handleFilterAcrossProductsChange}
            />
        </Button>
    );
}

// Typechecking props for the OverallKpi
FilterAcrossProductsToggleComponent.propTypes = {
    type: PropTypes.string,
};

export default FilterAcrossProductsToggleComponent;
